import {Flex, HStack, Link as ChakraLink, Spacer, Image, Box, Heading} from '@chakra-ui/react';
import React from 'react';
import {Link} from 'react-router-dom';

const Info = () => {
    return (
        <Box
            minHeight="100vh"
            width="100vw"
            backgroundImage="url('/images/cone.jpg')"
            backgroundSize="cover"
            backgroundPosition="center"
            display="flex"
            justifyContent="center"
            alignItems="center"
        >
            <Box
                bg="white"
                mt="89px"
                padding="5"
                borderRadius="md"
                boxShadow="lg"
                textAlign="center"
                width="2xl"
                display="flex"
                flexDirection="column"
                gap="10px"
            >
                <Heading
                    padding="3"
                    as="h2"
                    size="lg"
                >
                    Przydatne informacje
                </Heading>
                <ChakraLink href="https://confluence.zhr.pl/display/REG/Spisy+ZHR"
                            color="blue.500"
                            fontWeight="bold"
                            _hover={{
                                textDecoration: "none",
                                color: "brand.700"
                            }}
                            height="100%"
                >
                    Confluence z webinarem i instrukcjami
                </ChakraLink>
                <ChakraLink href="https://view.genially.com/679e031ee566c50afda26330/guide-instrukcja-spisowa"
                            color="brand.500"
                            fontWeight="bold"
                            _hover={{
                                textDecoration: "none",
                                color: "brand.700"
                            }}
                            height="100%"
                >
                    Instrukcje spisowe
                </ChakraLink>
                <ChakraLink href="https://docs.google.com/document/d/1TGY82A0XGyeByjujDT-dGOIMT9rZ9HVHYJKSqU6m89w/edit?usp=sharing"
                            color="brand.500"
                            fontWeight="bold"
                            _hover={{
                                textDecoration: "none",
                                color: "brand.700"
                            }}
                            height="100%"
                >
                    Pytania i odpowiedzi
                </ChakraLink>
                <ChakraLink href="https://jira.zhr.pl/servicedesk/customer/portal/1"
                            color="red.500"
                            fontWeight="bold"
                            _hover={{
                                textDecoration: "none",
                                color: "red.700"
                            }}
                            height="100%"
                >
                    Ratunku
                </ChakraLink>
            </Box>
        </Box>
    );
};

export default Info;